import styled from 'styled-components';

export const ErrorMessagePlaceholder = styled.span`
  display: block;
  color: ${({ theme }) => theme.formErrorMessage.colors.text};
`;
